import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--fy-background-primary)' }}>

      {/* Centered entrance */}
      <main className="flex-1 flex flex-col items-center justify-center px-4 pb-24">

        {/* Logo — large, grounded */}
        <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-3xl flex items-center justify-center overflow-hidden mb-6 shadow-lg" style={{ backgroundColor: 'var(--fy-background-secondary)' }}>
          <img src="https://customer-assets.emergentagent.com/job_kindplatform/artifacts/my73uiau_file_00000000f09c720c9463ab506718d330.png" alt="LikeKind" className="w-full h-full object-cover" />
        </div>

        {/* Title */}
        <h1 className="text-4xl sm:text-5xl font-black mb-4" style={{ fontFamily: 'Outfit', color: 'var(--fy-text-primary)' }} data-testid="landing-title">
          LikeKind
        </h1>

        {/* Headline — immediate understanding */}
        <p className="text-lg sm:text-xl text-center max-w-md mb-2 font-medium" style={{ color: 'var(--fy-text-primary)' }}>
          Find and start real-world activities near you.
        </p>
        <p className="text-base text-center max-w-sm mb-12" style={{ color: 'var(--fy-text-secondary)' }}>
          See what's happening. Join something. Or start something.
        </p>

        {/* Actions — clear, separated */}
        <div className="flex flex-col items-center gap-3 w-full max-w-xs">
          <Button
            onClick={() => navigate('/base-camp')}
            className="w-full h-12 rounded-full font-bold text-base"
            style={{ backgroundColor: 'var(--lk-sage)', color: '#fff' }}
            data-testid="browse-activities-btn"
          >
            Browse activities
          </Button>
          <Button
            onClick={() => navigate('/auth?mode=signup')}
            variant="outline"
            className="w-full h-12 rounded-full font-semibold text-base"
            style={{ borderColor: 'var(--fy-border-subtle)', color: 'var(--fy-text-primary)', backgroundColor: 'transparent' }}
            data-testid="create-account-btn"
          >
            Create account
          </Button>
          <button
            onClick={() => navigate('/auth?mode=signin')}
            className="mt-1 text-sm font-medium hover:opacity-70 transition-opacity"
            style={{ color: 'var(--fy-text-secondary)' }}
            data-testid="sign-in-btn"
          >
            Sign in
          </button>
        </div>
      </main>

      {/* Footer — visible, not blocked */}
      <footer className="py-6 pb-16 text-center" style={{ borderTop: '1px solid var(--fy-border-subtle)' }}>
        <div className="flex flex-wrap items-center justify-center gap-4 text-xs" style={{ color: 'var(--fy-text-secondary)' }}>
          <a href="/trust" className="hover:opacity-80">Trust</a>
          <a href="/privacy" className="hover:opacity-80">Privacy</a>
          <a href="/terms" className="hover:opacity-80">Terms</a>
          <a href="/faq" className="hover:opacity-80">FAQ</a>
          <a href="/founder-statement" className="hover:opacity-80">Founder's Letter</a>
        </div>
      </footer>
    </div>
  );
}
